import classNames from 'clsx';
import { noop } from 'es-toolkit';
import { useContext, useRef } from 'react';
import { SEE_MORE } from 'src/common/constants/localizations/containerItems';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from './load-more-items.module.scss';

interface SeeMoreLinkProps {
  onClick: () => Promise<unknown>;
}

export function SeeMoreLink({ onClick }: SeeMoreLinkProps) {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  // The next page only starts where this one ends once it has landed, so a second click while it is in flight
  // would request, and append, the same page again.
  const isFetching = useRef(false);

  const handleClick = async () => {
    if (isFetching.current) return;

    isFetching.current = true;

    // The API middleware has already reported a failure by the time the promise rejects.
    await onClick().catch(noop);

    isFetching.current = false;
  };

  return (
    <div className={classNames('row', css.container)}>
      <div className="col-xs-12">
        <a
          /* biome-ignore lint/a11y/useSemanticElements: TODO: explore changing to input or button */
          role="button"
          tabIndex={0}
          data-testid="containerLoadMoreLink"
          className={css.link}
          onClick={handleClick}
        >
          {getLocalizedText(SEE_MORE)}
        </a>
      </div>
    </div>
  );
}
